import { apiClient } from './apiClient';
import { LocalizedString } from '@sakeena/shared';

export interface PublicHeroSlide {
  id: string;
  /** Banner image URL — string (legacy) or per-language object (e.g. { ar: '...', en: '...' }). */
  imageUrl: string | (LocalizedString | Record<string, string>);
  title: LocalizedString | string;
  description: LocalizedString | string;
  primaryButtonText: LocalizedString | string;
  primaryButtonLink?: string;
  secondaryButtonText: LocalizedString | string;
  secondaryButtonLink?: string;
  order: number;
  isActive: boolean;
}

export interface SectionCard {
  id: string;
  title: LocalizedString | string;
  body: LocalizedString | string;
  imageUrl?: string;
  audioUrl?: string;
  audioDurationSeconds?: number;
  ctaText: LocalizedString | string;
  ctaLink: string;
  order: number;
  isActive: boolean;
}

function normalizeHeroSlide(raw: any): PublicHeroSlide {
  const id = raw?.id ?? raw?.Id ?? '';
  const imageUrl = raw?.imageUrl ?? raw?.ImageUrl ?? '';
  const title = raw?.title ?? raw?.Title ?? '';
  const description = raw?.description ?? raw?.Description ?? '';
  const primaryButtonText = raw?.primaryButtonText ?? raw?.PrimaryButtonText ?? '';
  const primaryButtonLink = raw?.primaryButtonLink ?? raw?.PrimaryButtonLink;
  const secondaryButtonText = raw?.secondaryButtonText ?? raw?.SecondaryButtonText ?? '';
  const secondaryButtonLink = raw?.secondaryButtonLink ?? raw?.SecondaryButtonLink;
  const order = raw?.order ?? raw?.Order ?? 0;
  const isActive = raw?.isActive ?? raw?.IsActive ?? true;
  return {
    id: String(id),
    imageUrl,
    title,
    description,
    primaryButtonText,
    primaryButtonLink: primaryButtonLink ?? undefined,
    secondaryButtonText,
    secondaryButtonLink: secondaryButtonLink ?? undefined,
    order: Number(order),
    isActive: !!isActive,
  };
}

const homePageApiService = {
  getActiveHeroSlides: async (lang?: string): Promise<PublicHeroSlide[]> => {
    const params = lang ? { lang } : undefined;
    const response = await apiClient.get('/homepage/hero-slides', { params, timeout: 15000 });
    const data = response.data;
    if (!Array.isArray(data)) return [];
    return data.map(normalizeHeroSlide);
  },
  getActiveSectionCards: async (): Promise<SectionCard[]> => {
    const response = await apiClient.get('/homepage/section-cards');
    return response.data;
  },
  getSectionCardById: async (id: string): Promise<SectionCard> => {
    const response = await apiClient.get(`/homepage/section-cards/${id}`);
    return response.data;
  },
};

export default homePageApiService;
